import {Divider} from '@chakra-ui/react'

const SectionDivider = () => <Divider borderColor="mld.neutral.500" />

export default SectionDivider
